import ObligationService from '@/shared/services/ObligationService';

/**
 * BE draft/search podržava action_plan_id; id se filtrira na klijentu.
 * @param {string} obligationId
 * @param {string|null} [actionPlanId]
 * @returns {Promise<object|null>}
 */
export async function searchDraftObligationById(obligationId, actionPlanId = null) {
  if (!obligationId) return null;

  const filters = actionPlanId ? { action_plan_id: actionPlanId } : {};
  const res = await ObligationService.searchDrafts(filters).catch(() => ({ obligations: [] }));
  const list = Array.isArray(res?.obligations) ? res.obligations : [];
  const found = list.find((o) => String(o?.id) === String(obligationId)) ?? null;
  if (!found) return null;
  return {
    ...found,
    status: found.status || 'DRAFT',
  };
}
